module.exports = __webpack_public_path__ + "img/rem6.9f967c39.jpg";